import React, { useState } from 'react';
import styled from 'styled-components';
import { Tab, TabList, TabPanel } from './index';
import { generateTabContent } from './shared/TabPanel';
const TabContainer = styled.div `
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 25px;
`;
const ListContainer = styled.li `
  z-index: 9;
  list-style: none;
  flex-grow: 1;
  flex-basis: 25%;
  width: auto;
  border-left: 2px solid ${({ theme }) => theme.greyLightMedium};

  :last-child {
    border-right: 2px solid ${({ theme }) => theme.greyLightMedium};
  }
`;
// TODO: ADD TESTS
export const DesktopTabs = ({ items }) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const tabsJSX = items.map((item, index) => {
        if (index > 3) {
            return null;
        }
        else {
            const tabLabel = item && item.fields && item.fields.tabLabel;
            return (React.createElement(ListContainer, { key: index },
                React.createElement(Tab, { isSelected: selectedIndex === index, field: tabLabel, index: index, itemId: item.id, onClick: () => setSelectedIndex(index) })));
        }
    });
    const tabItem = items[selectedIndex];
    const itemId = tabItem.id;
    const content = generateTabContent(tabItem);
    return (React.createElement(TabContainer, null,
        React.createElement(TabList, null, tabsJSX),
        React.createElement(TabPanel, { selectedIndex: selectedIndex, itemId: itemId }, content)));
};
